var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PartnerMarketingEventList'
      }
    }
  }, [_vm._v("點數/商品兌換活動")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? '編輯' : '新增') + "點數/商品兌換活動")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? '編輯' : '新增') + "點數/商品兌換活動 ")])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('b-form', {
    ref: "formRef",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "state": _vm.errors.name ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _vm.errors.name ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "圖片",
      "label-for": "image_url"
    }
  }, [_c('div', {
    staticClass: "image-selector"
  }, [_vm.form.image_url ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "max-width": "140px",
      "max-height": "80px"
    },
    attrs: {
      "src": _vm.form.image_url
    }
  }), !_vm.isView && !_vm.isLoading ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.form.image_url = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "selector"
  }, [!_vm.isView && !_vm.isLoading ? _c('ImageSelector', {
    on: {
      "input": _vm.uploadImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": openFileSelector
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" 圖片 ")])];
      }
    }], null, false, 3830516922)
  }) : _vm._e()], 1)]), _c('small', {
    staticStyle: {
      "color": "#7f8182"
    }
  }, [_vm._v("建議尺寸：300 x 300px，格式：jpg")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions,
      "state": _vm.errors.status ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }), _vm.errors.status ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.status))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "類型",
      "label-for": "type",
      "state": _vm.errors.type ? false : null
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "type",
      "options": _vm.typeOptions,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }), _vm.errors.type ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.type))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間",
      "label-for": "start_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": "",
      "disabledDates": _vm.startAtDisabledDates
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  })], 1), _vm.errors.start_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.start_at))]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.startAtValidationState
    }
  }, [_vm._v(_vm._s(_vm.startAtValidationMessage))])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間",
      "label-for": "end_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": "",
      "disabledDates": _vm.endAtDisabledDates
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  })], 1), _vm.errors.end_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.end_at))]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.endAtValidationState
    }
  }, [_vm._v(_vm._s(_vm.endAtValidationMessage))])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "兌換注意事項",
      "label-for": "notes"
    }
  }, [_c('classic-editor', {
    attrs: {
      "extra-plugins": [_vm.MyCustomUploadAdapterPlugin],
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "notes", $$v);
      },
      expression: "form.notes"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "排序",
      "label-for": "sort"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sort",
      "type": "number",
      "placeholder": "排序為必填",
      "state": _vm.errors.sort ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sort", $$v);
      },
      expression: "form.sort"
    }
  }), _vm.errors.sort ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.sort))]) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v("返回")]), !_vm.isView ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }